// src/db/visitorcheckoutselectApi.js
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
  serverTimestamp,
  getDoc
} from 'firebase/firestore';
import { db } from '../firebase';

// Get all approved visits by the current visitor
export const getApprovedVisitsByUser = async (uid) => {
  try {
    const q = query(
      collection(db, 'visit_approvals'),
      where('visitorUserID', '==', uid),
      where('status', '==', 'approved')
    );
    const snapshot = await getDocs(q);

    const visits = await Promise.all(
      snapshot.docs.map(async (docSnap) => {
        const data = docSnap.data();

        // Fetch host details from users collection
        let hostName = 'N/A';
        if (data.hostUserID) {
          try {
            const hostDocRef = doc(db, 'users', data.hostUserID);
            const hostDocSnap = await getDoc(hostDocRef);

            if (hostDocSnap.exists()) {
              const hostData = hostDocSnap.data();
              hostName =
                hostData.name ||
                hostData.fullName ||
                hostData.userName ||
                hostData.displayName ||
                'Unknown Host';
            }
          } catch (err) {
            console.error(`Error fetching host details for ${data.hostUserID}:`, err);
          }
        }

        return {
          id: docSnap.id,
          visitorName: data.visitorName || 'Unknown Visitor',
          visitorEmail: data.visitorEmail || '',
          visitorMobileNo: data.visitorMobileNo || '',
          visitReason: data.visitReason || '',
          approvedAt: data.approvedAt || null,
          status: data.status || '',
          hostUserID: data.hostUserID || '',
          hostName
        };
      })
    );

    return visits;
  } catch (error) {
    console.error('Error fetching approved visits:', error);
    throw error;
  }
};

// Conclude the visit (for operators)
export const concludeVisitById = async (visitId) => {
  try {
    const visitRef = doc(db, 'visit_approvals', visitId);
    await updateDoc(visitRef, {
      status: 'concluded',
      visitorCheckoutTime: serverTimestamp(),
    });
  } catch (error) {
    console.error('Error concluding visit:', error);
    throw error;
  }
};
